// Notification Helper - Utility to create notifications from anywhere in the app
import notificationApi from '../services/notificationApi';

/**
 * Helper to create notifications from various parts of the application
 */

// PR-related notifications
export const notifyPRPublished = async (prTitle: string, channelCount: number, prId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'pr_published',
      title: 'PR Successfully Published',
      message: `Your press release "${prTitle}" has been published to ${channelCount} channels.`,
      actionUrl: '/pr-library',
      metadata: { prId }
    });
  } catch (error) {
    console.error('Failed to create PR published notification:', error);
  }
};

export const notifyPRRejected = async (prTitle: string, reason: string, prId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'pr_rejected',
      title: 'PR Submission Requires Updates',
      message: `Your PR "${prTitle}" needs improvements. ${reason}`,
      actionUrl: '/pr-library',
      metadata: { prId }
    });
  } catch (error) {
    console.error('Failed to create PR rejected notification:', error);
  }
};

export const notifyPRSubmitted = async (prTitle: string, prId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'info',
      title: 'PR Submitted Successfully',
      message: `Your press release "${prTitle}" has been submitted for review.`,
      actionUrl: '/pr-library',
      metadata: { prId }
    });
  } catch (error) {
    console.error('Failed to create PR submitted notification:', error);
  }
};

export const notifyPRVerified = async (prTitle: string, prId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'success',
      title: 'PR Verified Successfully',
      message: `Your press release "${prTitle}" has been verified and is ready for distribution.`,
      actionUrl: '/pr-library',
      metadata: { prId }
    });
  } catch (error) {
    console.error('Failed to create PR verified notification:', error);
  }
};

// Payment-related notifications
export const notifyPaymentProcessed = async (amount: number, channelCount: number) => {
  try {
    await notificationApi.createNotification({
      type: 'payment',
      title: 'Payment Processed',
      message: `Your payment of $${amount} for ${channelCount} distribution channels has been processed successfully.`,
      actionUrl: '/payments',
      metadata: { paymentAmount: amount }
    });
  } catch (error) {
    console.error('Failed to create payment processed notification:', error);
  }
};

export const notifyPaymentFailed = async (amount: number, reason: string) => {
  try {
    await notificationApi.createNotification({
      type: 'warning',
      title: 'Payment Failed',
      message: `Your payment of $${amount} failed. ${reason}`,
      actionUrl: '/payments',
      metadata: { paymentAmount: amount }
    });
  } catch (error) {
    console.error('Failed to create payment failed notification:', error);
  }
};

// Campaign-related notifications
export const notifyCampaignStarted = async (campaignName: string, campaignId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'campaign',
      title: 'Campaign Started',
      message: `Your campaign "${campaignName}" has been launched successfully!`,
      actionUrl: '/campaigns',
      metadata: { campaignId }
    });
  } catch (error) {
    console.error('Failed to create campaign started notification:', error);
  }
};

export const notifyCampaignMilestone = async (campaignName: string, milestone: string, campaignId: string) => {
  try {
    await notificationApi.createNotification({
      type: 'campaign',
      title: 'Campaign Milestone Reached',
      message: `Your campaign "${campaignName}" ${milestone}!`,
      actionUrl: '/campaigns',
      metadata: { campaignId }
    });
  } catch (error) {
    console.error('Failed to create campaign milestone notification:', error);
  }
};

// Verification notifications
export const notifyVerificationApproved = async () => {
  try {
    await notificationApi.createNotification({
      type: 'success',
      title: 'Verification Approved',
      message: 'Your company verification has been approved. You can now access premium features.',
      actionUrl: '/verification'
    });
  } catch (error) {
    console.error('Failed to create verification approved notification:', error);
  }
};

export const notifyVerificationRejected = async (reason: string) => {
  try {
    await notificationApi.createNotification({
      type: 'warning',
      title: 'Verification Rejected',
      message: `Your verification was rejected. ${reason}`,
      actionUrl: '/verification'
    });
  } catch (error) {
    console.error('Failed to create verification rejected notification:', error);
  }
};

// System notifications
export const notifySystemMaintenance = async (scheduledTime: string) => {
  try {
    await notificationApi.createNotification({
      type: 'system',
      title: 'Scheduled Maintenance',
      message: `System maintenance scheduled for ${scheduledTime}. Services may be temporarily unavailable.`
    });
  } catch (error) {
    console.error('Failed to create system maintenance notification:', error);
  }
};

export const notifyNewFeature = async (featureName: string, featureUrl?: string) => {
  try {
    await notificationApi.createNotification({
      type: 'info',
      title: 'New Feature Available',
      message: `Try our new ${featureName} to improve your PR performance.`,
      actionUrl: featureUrl || '/dashboard'
    });
  } catch (error) {
    console.error('Failed to create new feature notification:', error);
  }
};

// Analytics notifications
export const notifyAnalyticsMilestone = async (milestone: string) => {
  try {
    await notificationApi.createNotification({
      type: 'success',
      title: 'Analytics Milestone',
      message: milestone,
      actionUrl: '/analytics'
    });
  } catch (error) {
    console.error('Failed to create analytics milestone notification:', error);
  }
};

// Generic notification creator
export const notifyGeneric = async (
  type: 'success' | 'warning' | 'info' | 'system',
  title: string,
  message: string,
  actionUrl?: string,
  metadata?: any
) => {
  try {
    await notificationApi.createNotification({
      type,
      title,
      message,
      actionUrl,
      metadata
    });
  } catch (error) {
    console.error('Failed to create generic notification:', error);
  }
};













































